import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface UpdateLocationData {
  latitude: number
  longitude: number
  city?: string | null
  country?: string | null
}

const updateLocation = async (data: UpdateLocationData) => {
  const { data: result } = await api.post('/ft_update-location', data)
  return result
}

export const useFtUpdateLocation = () => {
  return useMutation({
    mutationFn: updateLocation,
  })
}
